import NewGrowScreen from './NewGrowScreen';

export default NewGrowScreen;